const regular = {
  title: "regular",
  colors: {
    backgroundDark: "#2f3437",
    backgroundLight: "#373c3f",
    primary: "#589879",
    secundary: "#EAEBEB",
    separtor: "##373C3F",
  }
}

export default regular